import { styled } from '@mui/system';
import { Grid, ListItemText } from '@mui/material';

export const MenuItem = styled(ListItemText)(() => ({
  marginLeft: '20px'
}));

export const Menu = styled(Grid)(() => ({
  padding: '8px'
}));
